import { defineComponent as _defineComponent } from 'vue'
import { Stemdoer } from '@/shared/model/stemdoer.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'StemdoerAvailability',
  props: {
  stemdoer: {
    type: Object as () => Stemdoer,
    required: true
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})